import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";
import { useIntl } from "react-intl";
import { isOrderActive } from "@Components/LinkBetween/miScusiAndTakeAwayUtils";
import ScrollToTop from "@Src_main/utils/scrollToTop";
import CreateAccountPage from "@Components/CreateAccountPage";
import { env } from "build/env";
import { useExponea } from "@Src_main/utils/useExponea";
var OrderPage = lazy(() => import("@Pages/OrderPage/order"));
var OrderPageFromRestaurant = lazy(() => import("@Pages/OrderPage/orderFromRestaurant"));
var LoginPage = lazy(() => import("@Pages/LoginPage/loginPage"));
var CheckoutNormalPage = lazy(() => import("../overrides/venia-ui/components/CheckoutPage/checkoutNormalPage"));
var LoginFeedback = lazy(() => import("../pages/LoginFeedback"));
var PwdRecovery = lazy(() => import("../pages/PwdRecovery"));
var PreLogin = lazy(() => import("../pages/PreLogin"));
var MenuTakeaway = lazy(() => import("../pages/MenuTakeaway"));
var BookTable = lazy(() => import("../pages/BookTable"));
var Stores = lazy(() => import("../pages/Stores"));
var MyAccount = lazy(() => import("../pages/MyAccount"));
var Reservations = lazy(() => import("../pages/Reservations"));
var Orders = lazy(() => import("../pages/OrderDetails"));
var MyAccountData = lazy(() => import("../pages/MyAccountData"));
var CookieCheck = lazy(() => import("./../pages/CookiesCheck"));
var PuntiSeeds = lazy(() => import("../pages/PuntiSeeds"));
var TablePage = lazy(() => import("../pages/TableStatus/TablePage"));
var ReceiptRoot = lazy(() => import("../pages/Receipt/ReceiptRoot"));
var MagentoRoute = lazy(() => import("../overrides/venia-ui/components/MagentoRoute"));
var CouponPage = lazy(() => import("../pages/CouponPage/couponPage"));
var LinkTicketPage = lazy(() => import("../pages/LinkTicket/linkTicket"));
var KioskLoginRoot = lazy(() => import("../pages/KioskLogin/KioskLoginRoot"));
var Homepage = lazy(() => import("../pages/AppHomepage/appHomepage"));
var ExternalRedirect = () => {
  var {
    trackAllEvent
  } = useExponea();
  var {
    URL_MISCUSI
  } = env;
  var target = window.location.protocol + "//" + URL_MISCUSI + window.location.pathname;
  trackAllEvent("redirect_brand", {
    target_url: target
  });
  window.location.replace(target);
  return null;
};
var Routes = () => {
  var {
    formatMessage
  } = useIntl();
  var {
    IS_COUPON_ACTIVE
  } = env;
  var routeStructure = /*#__PURE__*/React.createElement(ScrollToTop, null, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/",
    component: MenuTakeaway
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.checkout"
    })
  }, /*#__PURE__*/React.createElement(CheckoutNormalPage, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.pre.login"
    })
  }, /*#__PURE__*/React.createElement(PreLogin, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.app.login"
    })
  }, /*#__PURE__*/React.createElement(PreLogin, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/login-feedback"
  }, /*#__PURE__*/React.createElement(LoginFeedback, null)), /*#__PURE__*/React.createElement(Route, {
    path: formatMessage({
      id: "url.key.book.a.table"
    })
  }, /*#__PURE__*/React.createElement(BookTable, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.restaurants"
    }) + "/:id/:param?",
    component: Stores
  }), /*#__PURE__*/React.createElement(Route, {
    path: formatMessage({
      id: "url.key.myaccount"
    })
  }, /*#__PURE__*/React.createElement(MyAccount, null)), /*#__PURE__*/React.createElement(Route, {
    path: formatMessage({
      id: "url.key.login"
    })
  }, /*#__PURE__*/React.createElement(LoginPage, {
    isLandingPage: true
  })), /*#__PURE__*/React.createElement(Route, {
    path: formatMessage({
      id: "url.key.signup"
    })
  }, /*#__PURE__*/React.createElement(CreateAccountPage, {
    isLandingPage: true,
    isPage: true,
    showHeader: false
  })), /*#__PURE__*/React.createElement(Route, {
    path: formatMessage({
      id: "url.key.loyalty.data"
    })
  }, /*#__PURE__*/React.createElement(MyAccountData, null)), /*#__PURE__*/React.createElement(Route, {
    path: formatMessage({
      id: "url.key.loyalty.reservations"
    })
  }, /*#__PURE__*/React.createElement(Reservations, null)), /*#__PURE__*/React.createElement(Route, {
    path: formatMessage({
      id: "url.key.loyalty.orders"
    })
  }, /*#__PURE__*/React.createElement(Orders, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.order"
    }),
    component: OrderPage
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "".concat(formatMessage({
      id: "url.key.order.from.restaurant"
    }), "/:restaurantId"),
    component: OrderPageFromRestaurant
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/checkCookies"
  }, /*#__PURE__*/React.createElement(CookieCheck, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.loyalty.history"
    })
  }, /*#__PURE__*/React.createElement(PuntiSeeds, null)), IS_COUPON_ACTIVE ? /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.coupon"
    })
  }, /*#__PURE__*/React.createElement(CouponPage, null)) : null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/customer/account/createPassword",
    component: PwdRecovery
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.pay"
    }),
    component: TablePage
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/payment/:paymentId",
    component: ReceiptRoot
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/kiosklogin/:connectionId/:challenge",
    component: KioskLoginRoot
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.loyalty.linkTicket"
    })
  }, /*#__PURE__*/React.createElement(LinkTicketPage, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.app.home"
    }),
    component: Homepage
  }), /*#__PURE__*/React.createElement(Route, {
    component: ExternalRedirect
  })));
  return routeStructure;
};
export default Routes;